import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/logo2.png";

export default function Footer() {
  const [showTop, setShowTop] = useState(false);

  // Show back-to-top button when user scrolls down
  useEffect(() => {
    const handleScroll = () => setShowTop(window.scrollY > 300);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const footerLinks = [
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
    { name: "Programs", path: "/programs" },
    { name: "Get Involved", path: "/get-involved" },
    { name: "Donate", path: "/donate" },
    { name: "Gallery", path: "/gallery" },
    { name: "Blog", path: "/blog" },
    { name: "Contact", path: "/contact" },
  ];

  return (
    <footer className="bg-[#2D033B] text-white relative">
      <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-3 gap-8">
        {/* About */}
        <div>
          <div className="bg-white p-5  rounded-[5px] mb-4 w-max">
            <img src={logo} alt="" className="h-40 object-cover w-auto" />
          </div>
          
          <h3 className="text-xl font-bold mb-4 text-[#EDE4F7]">
            Queen Esther's Foundation
          </h3>
          <p className="text-white leading-relaxed">
            We empower communities through education, healthcare, and social
            development initiatives, building a better future for all.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-xl font-bold mb-4 text-[#EDE4F7]">Quick Links</h3>
          <ul className="space-y-2 grid gap-2 grid-cols-2">
            {footerLinks.map((link) => (
              <li key={link.name}>
                <Link
                  to={link.path}
                  className="text-[#EDE4F7] hover:text-[#6A0DAD] font-medium transition"
                >
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h3 className="text-xl font-bold mb-4 text-[#EDE4F7]">Contact Us</h3>
          <p className="text-white font-medium">
            Email: info@queenesthersimpactfoundation.org
          </p>
          <p className="text-white font-medium">Phone: +234 901 811 4767</p>
          <p className="text-white font-medium">Address: Lagos, Nigeria</p>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="bg-[#EDE4F7] text-[#2D033B] text-center py-4">
        © {new Date().getFullYear()} Queen Esther's Foundation. All rights reserved.
      </div>

      {/* Back to Top Button */}
      {showTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-6 right-6 bg-[#6A0DAD] text-white p-3 rounded-full shadow-lg hover:bg-[#5F0F99] transition z-50"
          aria-label="Back to Top"
        >
          ↑
        </button>
      )}
    </footer>
  );
}
